import React, { useEffect } from "react";
import { Headphones } from "lucide-react";

/**
 * Renders a brief "Audio experience moved" message and replaces the window
 * location with /audio-comics after 1s. We also use <meta refresh> as a
 * defence-in-depth fallback for crawlers that disable JS.
 */
export default function LegacyRedirect() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.replace("/audio-comics");
    }, 1000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-[#0e0a14] text-white flex items-center justify-center px-6" data-testid="legacy-redirect">
      <meta httpEquiv="refresh" content="1;url=/audio-comics" />
      <link rel="canonical" href="https://balabasava.com/audio-comics" />
      <div className="text-center max-w-md">
        <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-fuchsia-500 to-amber-400 grid place-items-center shadow-lg">
          <Headphones size={22} strokeWidth={2.2} />
        </div>
        <div className="text-[11px] uppercase tracking-[0.25em] text-amber-300 mb-3">Moved</div>
        <h1 className="text-2xl sm:text-3xl font-semibold leading-tight">
          Audio experience moved to the new Bala Basava Audio Comics platform.
        </h1>
        <p className="mt-4 text-white/60 text-sm">
          Taking you there now…&nbsp;
          <a href="/audio-comics" className="text-amber-300 underline">go now</a>
        </p>
      </div>
    </div>
  );
}
